module.exports = __webpack_public_path__ + "media/img/biznes-icon-eae019ea.svg";